import { defineMessages } from "react-intl";

export default defineMessages({
  addPatientTitle: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.addPatientTitle",
    defaultMessage: "Add Patient",
  },
  firstNameLabel: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.firstNameLabel",
    defaultMessage: "First name",
  },
  lastNameLabel: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.lastNameLabel",
    defaultMessage: "Last name",
  },
  dateOfBirthLabel: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.dateOfBirthLabel",
    defaultMessage: "Date of birth",
  },
  dateOfBirthHelper: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.dateOfBirthHelper",
    defaultMessage: "Use format mm/dd/yyyy",
  },
  dateOfBirthPlaceholder: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.dateOfBirthPlaceholder",
    defaultMessage: "mm/dd/yyyy",
  },
  cancelButton: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.cancelButton",
    defaultMessage: "Cancel",
  },
  saveButton: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.saveButton",
    defaultMessage: "Save",
  },
  requiredField: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.requiredField",
    defaultMessage: "This field is required",
  },
  dateIsInvalid: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.dateIsInvalid",
    defaultMessage: "Date is invalid",
  },
  isLegalGuardianLabel: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.isLegalGuardianLabel",
    defaultMessage: "I am this patient's legal guardian",
  },
  isFamilyMemberLabel: {
    id: "Appointment.AppointmentCheckoutAddPatientModal.isFamilyMemberLabel",
    defaultMessage: "I am a family member of this patient",
  },
});
